import {jwtDecode } from 'jwt-decode';
 
 const checkTokenValidity = (token) => {
   try {
      //Decode the token
     const decodedToken = jwtDecode(token);
 //Check if the token is expired
    const isTokenExpired = Date.now() >= decodedToken.exp * 1000;

     return !isTokenExpired;
   } catch (error) {
     // If there's an error decoding the token, consider it invalid
     return false;
   }
 };

 export { checkTokenValidity }